@switch (message.status) {
  @case ('loading') {
    <app-chat-answer-loading />
  }
  @case ('error') {
    <app-chat-answer-error />
  }
  @default {
    <app-markdown [markdown]="message.answer" />
  }
}
